import React from "react";

function Spinner(): React.ReactElement {
  return (
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}

export default Spinner;
